import React, { Component } from 'react'
import { Loading } from '@myxplor/ui'
import LocalAsyncStore from '../../../../../local-async-store'
import BookingScheduleForm from '../update-enrolment-schedule/form/container'
import { groupBookingsByDay, flattenBookingsByWeek } from '../update-enrolment-schedule/helpers'
import { defaultCasualSession, isFortnightlyPattern } from '../update-enrolment-schedule/form/helpers'

export const updateSubmitValues = (values) => {
  const is_fortnightly = values.is_fortnightly
  const is_casual = values.is_casual
  
  const submitValues = {
    ...values,
    enrolment_params: {
      ...values.enrolment_params,
      Sessions: {
        week1: !is_casual ? flattenBookingsByWeek(values.week1) : [],
        week2: is_fortnightly && isFortnightlyPattern(values) ? flattenBookingsByWeek(values.week2) : null,
        casual: is_casual ? [values.casual] : null,
      },
    },
  }

  delete submitValues.week1
  delete submitValues.week2
  delete submitValues.casual
  return submitValues
}

class EnrolmentBookingSchedule extends Component {
  constructor(props) {
    super(props)

    if (Array.isArray(props.booking_schedule)) return
    const { booking_schedule } = props

    let defaultValues = {
      week1: groupBookingsByDay(booking_schedule.enrolment_schedule.week1 || []),
      week2: groupBookingsByDay(booking_schedule.enrolment_schedule.week2 || null),
      casual: defaultCasualSession(booking_schedule.care_enrolments),
      reference_date: booking_schedule.reference_date || '',
      is_fortnightly: false,
      is_casual: false
    }

    props.onChange(['week1'], defaultValues.week1)
    props.onChange(['week2'], defaultValues.week2)
    props.onChange(['casual'], defaultValues.casual)
    props.onChange(['reference_date'], defaultValues.reference_date)
    props.onChange(['is_fortnightly'], defaultValues.is_fortnightly)
    props.onChange(['is_casual'], defaultValues.is_casual)
  }


  render() {
    if (!this.props.values.week1) return null

    return (
      <fieldset>
        <legend>Routine Sessions</legend>
        <BookingScheduleForm
          careEnrolmentOptions={this.props.booking_schedule.care_enrolments}
          {...this.props}
        />
      </fieldset>
    )
  }
}

const EnrolmentBookingScheduleContainer = props => {
  const { loading, data } = props.accs_booking_schedule
  if (loading) return <Loading>Loading Booking Schedule</Loading>

  return <EnrolmentBookingSchedule booking_schedule={data} {...props} />
}

const apiEndPoint = props => `${props.baseEndpoint}/parents/${props.parent_id}/enrolment-schedule`

export default LocalAsyncStore(
  'accs_booking_schedule',
  EnrolmentBookingScheduleContainer,
  apiEndPoint
)



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/enrolment-booking-schedule.js